module.exports = __webpack_public_path__ + "static/aaron-dfd3d21ab21dfc020f83d4564c6f8c8e.png";